import { EntityType, IGetActionLogsDTO } from '@/models/logs.model';
import { PaginationFields } from '@/models/pagination.model';
import { getEntityId } from '@/utils';

class GetActionLogsDTO implements IGetActionLogsDTO {
  id: string;
  entityType: EntityType;
  [PaginationFields.CURSOR]?: string;
  [PaginationFields.LIMIT]?: number;

  constructor(data: IGetActionLogsDTO) {
    this.id = getEntityId(data.id);
    this.entityType = data.entityType;
    this[PaginationFields.CURSOR] = data[PaginationFields.CURSOR];
    this[PaginationFields.LIMIT] = data[PaginationFields.LIMIT] ?? 10;
  }
}

export default GetActionLogsDTO;
